import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pulsedive = defineConnector({
  identifier: "pulsedive",
  name: "Pulsedive",
  tagLine: "Threat intelligence platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://pulsedive\\.com/api/.*",
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Pulsedive](https://pulsedive.com/) and create an account. Navigate to your account settings to generate an API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Pulsedive API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://pulsedive.com/api/info.php?indicator=pulsedive.com",
  },
});
